export const CONTACT_US = 'CONTACT_US';
export const CONTACT_CONFIRMATION = 'CONTACT_CONFIRMATION';
export const DOWNLOAD_APP = 'DOWNLOAD_APP';
